import { render } from "./bh-model.vue?vue&type=template&id=5951a885&scoped=true"
import script from "./bh-model.vue?vue&type=script&lang=js"
export * from "./bh-model.vue?vue&type=script&lang=js"

import "./bh-model.vue?vue&type=style&index=0&id=5951a885&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5951a885"]])

export default __exports__